import React from 'react';

import groupBy from 'lodash/groupBy';
import { TransitionGroup, Transition } from 'react-transition-group';

import { STATE_TRANSITION_DURATION } from './constants';
import { selector } from './store/selector';
import { useToastStore } from './store/toastStore';
import { ToastConfiguration, ToastTypes } from './store/types';
import { ToastDefaultStage, ToastLightPopoverStage } from './styles';
import { Toast } from './Toast';
import { ToastTheme } from './types';

/** Apply config values acting as shorthand for specific theme values. */
export const getThemeWithOverrides = (
  config: ToastConfiguration,
  theme: ToastTheme
): ToastTheme => ({ ...theme, height: config.small ? 30 : theme.height });

const ToastQueue: React.FC = () => {
  const groupedQueue = groupBy(useToastStore(selector.queue), 'type');
  const defaultQueue = groupedQueue[ToastTypes.DEFAULT] || [];
  const lightPopoverQueue = groupedQueue[ToastTypes.LIGHT_POPOVER] || [];

  return (
    <>
      <ToastDefaultStage>
        <TransitionGroup component={null}>
          {defaultQueue.map((c) => (
            <Transition key={c.id} timeout={STATE_TRANSITION_DURATION}>
              {(state): JSX.Element => (
                <Toast
                  error={c.error}
                  small={c.small}
                  theme={getThemeWithOverrides(c, c.theme)}
                  transitionStatus={state}
                >
                  {c.label}
                </Toast>
              )}
            </Transition>
          ))}
        </TransitionGroup>
      </ToastDefaultStage>
      <ToastLightPopoverStage>
        <TransitionGroup component={null}>
          {lightPopoverQueue.map((c) => (
            <Transition key={c.id} timeout={STATE_TRANSITION_DURATION}>
              {(state): JSX.Element => (
                <>
                  <Toast
                    error={c.error}
                    theme={getThemeWithOverrides(c, c.theme)}
                    transitionStatus={state}
                    type={c.type}
                  >
                    {c.label}
                  </Toast>
                </>
              )}
            </Transition>
          ))}
        </TransitionGroup>
      </ToastLightPopoverStage>
    </>
  );
};

export default ToastQueue;
